import { Http } from '@gamiphy/http';
import { Category, Product, ProductCategory } from '@gamiphy/bl/product';

export class ProductApi {
  public static async getProducts(): Promise<Product[]> {
    const response = await Http.get<ProductsResponse>({
      url: '/v2/products',
    });
    return response.data.products;
  }

  public static async listProductCategories(options?: { search?: string }): Promise<ProductCategory[]> {
    const response = await Http.get<{ categories: ProductCategory[] }>({
      url: '/v2/categories',
      query: {
        ...options?.search && {
          search: options?.search,
        },
      },
    });
    return response.data.categories;
  }

  public static async getProductCategory(id: string): Promise<ProductCategory> {
    const response = await Http.get<{ category: ProductCategory }>({
      url: `/v2/categories/${id}`,
    });
    return response.data.category;
  }

  public static async getProduct(productId: string): Promise<Product> {
    const response = await Http.get<GetProductResponse>({
      url: `/v2/products/${productId}`,
    });

    return response.data.product;
  }

  public static async getExternalProduct(productId: string): Promise<Product> {
    const response = await Http.get<GetProductResponse>({
      url: `/v2/products/external-id/${productId}`,
    });
    return response.data.product;
  }

  public static async getViewedProducts(): Promise<Product[] | []> {
    const response = await Http.get<GetViewedProductsResponse>({
      url: '/v2/products/viewed',
    });
    return response.data.products;
  }

  public static async getProductByExternalId(externalId: string): Promise<Product> {
    const response = await Http.get<GetProductResponse>({
      url: `/v2/products/external-id/${externalId}`,
    });

    return response.data.product;
  }

  public static async getPopularProducts(): Promise<Product[] | []> {
    const response = await Http.get<ProductsResponse>({
      url: '/v2/products/popular',
      query: {
        limit: 8,
      },
    });
    return response.data.products;
  }

  public static async getPopularCategories(): Promise<Category[] | []> {
    const response = await Http.get<CategoriesResponse>({
      url: '/v2/products/category/popular',
      query: {
        limit: 8,
      },
    });
    return response.data.categories;
  }

  public static async getPopularProductsByCategory(category: string): Promise<Product[] | []> {
    const response = await Http.get<ProductsResponse>({
      url: '/v2/products/popular',
      query: {
        limit: 8,
        category,
      },
    });
    return response.data.products;
  }

  public static async getPopularProductsByKeyword(keyword: string): Promise<Product[] | []> {
    const response = await Http.get<ProductsResponse>({
      url: '/v2/products/search',
      query: {
        keyword: keyword || undefined,
      },
    });
    return response.data.products;
  }
}

export type ProductsResponse = {
  products: Product[] | []
}

export type CategoriesResponse = {
  categories: Category[] | []
}

export type GetProductResponse = {
  product: Product,
}

export type GetViewedProductsResponse = {
  products: Product[] | [],
  count: number
}
